<template>
  <div 
    class="xit-fb-template node" 
    @dblclick.stop="handleClick(node)"
    :class="[camelCase(node.name), hasData(node), isSelected(node)]" 
  >
    <div class="title">
      <p class="title-content"><i class="far fa-hand-pointer card-audio-icon"></i> {{node.lingualName}}</p>
    </div>

    <div class="card-body-handler card_data_body p-0">
      <div class="card-data list-small-padded">
        <p 
          class="text-center mb-2 postback_title"
          v-if="node.data.actionType && node.data.actionTypeText"
        >{{ node.data.actionTypeText }}</p>

        <div v-if="node.data.actionType && 'messenger_engagement_plugin' === node.data.actionType">
          <div class="list-group" v-if="node.data.pluginType && ('checkbox_plugin' === node.data.pluginType || 'send_to_messenger' === node.data.pluginType)">
            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ plugin_type }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.pluginTypeText || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ domain }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.domain || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ language }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.languageText || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="'send_to_messenger' === node.data.pluginType && node.data.ctaButtonTypeText">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ cta_button_text }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.ctaButtonTypeText}} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="'checkbox_plugin' === node.data.pluginType">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ plugin_skin }}</small>
                <h6 class="mb-1 card-data-title">{{ ('light' === node.data.pluginSkin) ? plugin_skin_dark : plugin_skin_light }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="'send_to_messenger' === node.data.pluginType">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ plugin_skin }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.pluginSkin ? startCase(node.data.pluginSkin) : '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="'checkbox_plugin' === node.data.pluginType">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ center_align }} </small>
                <h6 class="mb-1 card-data-title">{{ 'true' === node.data.pluginCenterAlign ? center_align_yes : center_align_no }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ plugin_size }}</small>
                <h6 class="mb-1 card-data-title"> {{ node.data.pluginSize ? startCase(node.data.pluginSize) : '' }} </h6>              
              </div>           
            </span>

            <!-- <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="node.data.redirectionStatus && node.data.redirectionUrlForSuccessfulOptin">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ optin_success_redirect_url }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.redirectionUrlForSuccessfulOptin }} </h6>              
              </div>           
            </span> -->

            <!-- <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="('1' === node.data.redirectionStatus) && node.data.optInSuccessMessage">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ optin_success_message_in_website }}</small>
                <h6 class="mb-1 card-data-title">{{  node.data.optInSuccessMessage }} </h6>              
              </div>           
            </span> -->

            <span v-if="('1' === node.data.addingButtonInSuccessMessage) && ('0' === node.data.redirectionStatus)">
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonText">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_text }}</small>
                  <h6 class="mb-1 card-data-title">{{ node.data.buttonText }} </h6>              
                </div>           
              </span>
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonUrl">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_url }}</small>
                  <h6 class="mb-1 card-data-title">{{ node.data.buttonUrl }} </h6>              
                </div>           
              </span>
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonBgColor">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_background_color }}</small>
                  <h6 class="mb-1 card-data-title"><span class="border py-0 px-2" :style="'background:'+node.data.buttonBgColor"></span></h6>              
                </div>           
              </span>
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonTextColor">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_text_color }}</small>
                  <h6 class="mb-1 card-data-title"><span class="border py-0 px-2" :style="'background:'+node.data.buttonTextColor"></span></h6>              
                </div>           
              </span>
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonHoverBgColor">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_hover_background_color }}</small>
                  <h6 class="mb-1 card-data-title"><span class="border py-0 px-2" :style="'background:'+node.data.buttonHoverBgColor"></span></h6>              
                </div>           
              </span>
              <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonHoverTextColor">
                <div class="d-flex w-100 justify-content-between">
                  <small class="text-muted">{{ button_text_hover_color }}</small>
                  <h6 class="mb-1 card-data-title"> <span class="border py-0 px-2" :style="'background:'+node.data.buttonHoverTextColor"></span></h6>              
                </div>           
              </span>
            </span>

            <!-- <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="node.data.checkboxValidationErrorMessage">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ checkbox_validation_error_message }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.checkboxValidationErrorMessage }} </h6>              
              </div>           
            </span> -->

          </div>

          <div class="list-group" v-if="node.data.pluginType && 'm_me_link' === node.data.pluginType">
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonText">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_text }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.buttonText}} </h6>              
              </div>           
            </span>
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonBgColor">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_background_color }}</small>
                <h6 class="mb-1 card-data-title"> <span class="border py-0 px-2" :style="'background:'+node.data.buttonBgColor"></span></h6>              
              </div>           
            </span>
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonTextColor">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_text_color }}</small>
                <h6 class="mb-1 card-data-title"> <span class="border py-0 px-2" :style="'background:'+node.data.buttonTextColor"></span></h6>              
              </div>           
            </span>
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonHoverBgColor">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_hover_background_color }}</small>
                <h6 class="mb-1 card-data-title"> <span class="border py-0 px-2" :style="'background:'+node.data.buttonHoverBgColor"></span></h6>              
              </div>           
            </span>
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonHoverTextColor">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_text_hover_color }}</small>
                <h6 class="mb-1 card-data-title"> <span class="border py-0 px-2" :style="'background:'+node.data.buttonHoverTextColor"></span></h6>              
              </div>           
            </span>
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.buttonSize">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ button_size }}</small>
                <h6 class="mb-1 card-data-title">{{ startCase(node.data.buttonSize) }} </h6>              
              </div>           
            </span>
          </div>

          <div class="list-group" v-if="node.data.pluginType && 'customer_chat_plugin' === node.data.pluginType">
            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ plugin_type }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.pluginTypeText || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ domain }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.domain || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ language }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.languageText || '' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="node.data.chatPluginLoadingStatus">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ chat_plugin_loading }}</small>
                <h6 class="mb-1 card-data-title">{{ startCase(node.data.chatPluginLoadingStatus) }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="node.data.chatPluginLoadingDelayInSeconds">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ loading_delay_seconds }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.chatPluginLoadingDelayInSeconds + ' sec' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start"  v-if="node.data.chatPluginThemeColor">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ theme_color }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.chatPluginThemeColor }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.hideChatPluginIfNotLoggedIn && false">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ do_not_show_if_not_logged_in }}</small>
                <h6 class="mb-1 card-data-title">{{ '1' === node.data.hideChatPluginIfNotLoggedIn ? 'Yes' : 'No' }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.greetingTextIfLoggedIn">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ greeting_text_if_logged_in_to_facebook }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.greetingTextIfLoggedIn }} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.greetingTextIfNotLoggedIn">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ greeting_text_if_not_logged_in_to_facebook }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.greetingTextIfNotLoggedIn }} </h6>              
              </div>           
            </span>

          </div>

          <div class="list-group" v-if="node.data.actionType && 'messenger_engagement_plugin' === node.data.actionType">
            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.reference">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ reference }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.reference}} </h6>              
              </div>           
            </span>

            <span class="list-group-item list-group-item-action flex-column align-items-start" v-if="node.data.labelIdTextsArray && node.data.labelIdTextsArray.length > 0">
              <div class="d-flex w-100 justify-content-between">
                <small class="text-muted">{{ labels }}</small>
                <h6 class="mb-1 card-data-title">{{ node.data.labelIdTextsArray.join(', ') }} </h6>              
              </div>           
            </span>
          </div>

        </div>
      </div>

      <div class="card-sockets">
        <div class="output_content">
          <div class="output text-right" v-for="output in outputs()" :key="output.key" :class="hasConnection(output) ? 'has-connection' : ''">
            <div class="output-title">{{output.name}}</div>
            <Socket v-socket:output="output" type="output" :socket="output.socket"></Socket>
          </div>
        </div>
        <div class="input_content">
          <div class="input text-left" v-for="input in inputs()" :key="input.key" :class="hasConnection(input) ? 'has-connection' : ''">
            <Socket v-socket:input="input" type="input" :socket="input.socket"></Socket>
            <div class="input-title">{{input.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueRenderPlugin from 'rete-vue-render-plugin'

import { lang } from '../../assets/lang'
import { templateComponentMethods } from '../../utils/functions'

export default {
  name: 'AudioTemplate',
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },

  data: () => ({
    baseUrl: window.xitFlowBuilderData.base_url,
    
    plugin_type: lang.action_button_html_plugin_type,
    domain: lang.action_button_html_domain,
    language: lang.action_button_html_language,
    cta_button_text: lang.action_button_html_cta_button_text,
    plugin_skin: lang.action_button_html_plugin_skin,
    plugin_skin_light: lang.action_button_html_plugin_skin_light,
    plugin_skin_dark: lang.action_button_html_plugin_skin_dark,
    plugin_skin_blue: lang.action_button_html_plugin_skin_blue,
    center_align: lang.action_button_html_center_align,
    center_align_yes: lang.action_button_html_center_align_yes,
    center_align_no: lang.action_button_html_center_align_no,
    plugin_size: lang.action_button_html_plugin_size,

    optin_success_redirect_url: lang.action_button_html_optin_success_redirect_url,
    optin_success_message_in_website: lang.action_button_html_optin_success_message_in_website,

    button_text: lang.action_button_html_button_text,
    button_url: lang.action_button_html_button_url,
    button_background_color: lang.action_button_html_button_background,
    button_text_color: lang.action_button_html_button_text_color,
    button_hover_background_color: lang.action_button_html_button_hover_background,
    button_text_hover_color: lang.action_button_html_button_text_hover_color,
    button_size: lang.action_button_html_button_size,

    checkbox_validation_error_message: lang.action_button_html_checkbox_validation_error_message,

    chat_plugin_loading: lang.action_button_html_chat_plugin_loading,
    loading_delay_seconds: lang.action_button_html_loading_delay_seconds,
    theme_color: lang.action_button_html_theme_color,
    do_not_show_if_not_logged_in: lang.action_button_html_do_not_show_if_not_logged_in,
    greeting_text_if_logged_in_to_facebook: lang.action_button_html_greeting_text_if_logged_in_to_facebook,
    greeting_text_if_not_logged_in_to_facebook: lang.action_button_html_greeting_text_if_not_logged_in_to_facebook,
    reference: lang.action_button_html_reference,
    labels: lang.action_button_html_select_labels,
  }),

  methods: {
    ...templateComponentMethods,
  }
}
</script>